import AvailabilitiesTable from './AvailabilitiesTable';

export default AvailabilitiesTable;
